<template>
  <div class="data-list-container">
<vs-card v-if="actionlist.length" >
      <div slot="header">
        <h3>Set module access for {{$route.params.childName}}</h3>
      </div>
      
      <div class="flex flex-wrap">

  <div class="lg:w-1/4 sm:w-1/2 w-full p-1"
  v-for="list in actionlist" :key="list.role_action_id"
  >
  <div class="flex" style="box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2); background: #41cfdd; color: #fff; padding: 5px; border-radius: 5px;">
    <div>
      <vs-checkbox 
        class="white_checkbox"
        v-model="list.enabled"
        color="success"
        @change="permission(list.enabled,list.platform_module_id)"
        />
    </div>
    <div>
      <h4 style="color: #fff;">{{ list.module_name }}</h4>
    </div>
  </div>              


           </div>


</div>

</vs-card>


<vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button style="float:right" @click="saveButton">Back</vs-button>

</vs-row>

  </div>
</template>

<script>
import {FetchPlatformModuleAccessChild, ModluePermission} from '@/api/accessmanagement'
export default {
  data () {
    return {
      actionlist:[]
          
    }
  },

  mounted () {
    if (!this.$route.params.childId) {
      this.$router.push({name:'acess-management'})
    }
    console.log(this.$route.params.childId)
    this.fetch_platform_module_access()
  },
  methods:{
    
    async fetch_platform_module_access () {
      try {
        const {data} = await FetchPlatformModuleAccessChild(this.$route.params.childId)
        this.actionlist = data.data.list
        console.log(this.actionlist)
      } catch (e) {
        console.log(e)
      }
    },
    permission (enable,  platformmoduleid) {
      const payload = {
        // client_role_action_id : roleactionid,
        platform_module_id  : platformmoduleid,
        enabled  : enable ? 1 : 0,
        client_role_id : this.$route.params.moduleId,
        child_id:this.$route.params.childId

      }
      console.log(payload)

      this.PermissionModuleSet(payload)
      
    },
    async PermissionModuleSet (payload) {
      console.log(payload)
      this.$vs.loading()

      try {
        await ModluePermission(payload)
        this.$vs.notify({
          title: 'Success',
          text: 'Platform Module Action Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$vs.loading.close()

      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    saveButton () {
      //console.log('hi')
      this.$router.push({ name:'acess-management'})

    }
  }
}
</script>

<style scoped>
  .vs-checkbox--input {
    height: 100px;
    width: 100px;
  }
</style>
<style>
.white_checkbox .checkbox_x.vs-checkbox {
  border: 1px solid #fff !important;
}
</style>